<div class="section-wrapper">
  <h5>
    {{ title() }}
    <mohlel-info-tooltip
      class="mx-2"
      [content]="'home.top-low-companies-tooltip' | translate"
      [metricName]="'top_low_companies'"
    />
  </h5>
  <p-tabs value="0">
    <p-tablist>
      <p-tab value="0"
        >{{ 'home.top-high' | translate }} <i class="pi pi-arrow-up-right d-lg-none mx-2"></i
      ></p-tab>
      <p-tab value="1"
        >{{ 'home.top-low' | translate }} <i class="pi pi-arrow-down-right d-lg-none mx-2"></i
      ></p-tab>
      <p-tab value="2"
        >{{ 'home.top-volume' | translate }} <i class="pi pi-chart-bar d-lg-none mx-2"></i>
      </p-tab>
      <p-tab value="3"
        >{{ 'home.top-value' | translate }} <i class="pi pi-chart-line d-lg-none mx-2"></i
      ></p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <div class="row">
          <div class="col-12">
            @for (item of data().topGainers; track item.id) {
              <div class="company-card">
                <div class="company-info cursor-pointer" (click)="onNavigate(item)">
                  @if (showAvatar()) {
                    <p-avatar shape="circle">
                      <img [src]="item.imageUrl" [alt]="item.name" />
                    </p-avatar>
                  }
                  <div class="company-details">
                    <span class="company-name text-truncate">{{ item.name }}</span>
                    @if (showSymbol()) {
                      <span class="company-symbol">{{ item.symbol }}</span>
                    }
                  </div>
                </div>
                <div class="company-stats">
                  <span class="market-value">{{
                    numberFormatterUtil.formatNumberWithSuffixes(item.marketCap ?? 0)
                  }}</span>
                  <div class="price-change">
                    <span class="percentage-change positive">{{ item.changePercentage }}%</span>
                    <span class="price-volume">{{
                      numberFormatterUtil.formatNumberWithSuffixes(item.volume ?? 0)
                    }}</span>
                  </div>
                </div>
              </div>
            } @empty {
              <mohlel-empty-state />
            }
          </div>
        </div>
      </p-tabpanel>
      <p-tabpanel value="1">
        <div class="row">
          <div class="col-12">
            @for (item of data().topLosers; track item.id) {
              <div class="company-card">
                <div class="company-info cursor-pointer" (click)="onNavigate(item)">
                  @if (showAvatar()) {
                    <p-avatar shape="circle">
                      <img [src]="item.imageUrl" [alt]="item.name" />
                    </p-avatar>
                  }
                  <div class="company-details">
                    <span class="company-name">{{ item.name }}</span>
                    @if (showSymbol()) {
                      <span class="company-symbol">{{ item.symbol }}</span>
                    }
                  </div>
                </div>
                <div class="company-stats">
                  <span class="market-value">{{
                    numberFormatterUtil.formatNumberWithSuffixes(item.marketCap ?? 0)
                  }}</span>
                  <div class="price-change">
                    <span class="percentage-change negative"
                      >{{ item.changePercentage?.toFixed(2) }}%</span
                    >
                    <span class="price-volume">{{
                      numberFormatterUtil.formatNumberWithSuffixes(item.volume ?? 0)
                    }}</span>
                  </div>
                </div>
              </div>
            } @empty {
              <mohlel-empty-state />
            }
          </div>
        </div>
      </p-tabpanel>
      <p-tabpanel value="2">
        <div class="row">
          <div class="col-12">
            @for (item of data().topVolume; track item.id) {
              <div class="company-card">
                <div class="company-info cursor-pointer" (click)="onNavigate(item)">
                  @if (showAvatar()) {
                    <p-avatar shape="circle">
                      <img [src]="item.imageUrl" [alt]="item.name" />
                    </p-avatar>
                  }
                  <div class="company-details">
                    <span class="company-name text-truncate">{{ item.name }}</span>
                    @if (showSymbol()) {
                      <span class="company-symbol">{{ item.symbol }}</span>
                    }
                  </div>
                </div>
                <div class="company-stats">
                  <span class="market-value">{{
                    numberFormatterUtil.formatNumberWithSuffixes(item.marketCap ?? 0)
                  }}</span>
                  <div class="price-change">
                    <span
                      [class]="
                        item.changePercentage && item.changePercentage >= 0
                          ? 'percentage-change positive'
                          : 'percentage-change negative'
                      "
                    >
                      {{ item.changePercentage?.toFixed(2) }}%
                    </span>
                    <span class="price-volume">{{
                      numberFormatterUtil.formatNumberWithSuffixes(item.volume ?? 0)
                    }}</span>
                  </div>
                </div>
              </div>
            } @empty {
              <mohlel-empty-state />
            }
          </div>
        </div>
      </p-tabpanel>
      <p-tabpanel value="3">
        <div class="row">
          <div class="col-12">
            @for (item of data().topValue; track item.id) {
              <div class="company-card">
                <div class="company-info cursor-pointer" (click)="onNavigate(item)">
                  @if (showAvatar()) {
                    <p-avatar shape="circle">
                      <img [src]="item.imageUrl" [alt]="item.name" />
                    </p-avatar>
                  }
                  <div class="company-details">
                    <span class="company-name text-truncate">{{ item.name }}</span>
                    @if (showSymbol()) {
                      <span class="company-symbol">{{ item.symbol }}</span>
                    }
                  </div>
                </div>
                <div class="company-stats">
                  <span class="market-value">{{
                    numberFormatterUtil.formatNumberWithSuffixes(item.value ?? 0)
                  }}</span>
                  <div class="price-change">
                    <span
                      [class]="
                        item.changePercentage && item.changePercentage >= 0
                          ? 'percentage-change positive'
                          : 'percentage-change negative'
                      "
                    >
                      {{ item.changePercentage?.toFixed(2) }}%
                    </span>
                    <span class="price-volume">{{
                      numberFormatterUtil.formatNumberWithSuffixes(item.volume ?? 0)
                    }}</span>
                  </div>
                </div>
              </div>
            } @empty {
              <mohlel-empty-state />
            }
          </div>
        </div>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
